import {api} from '../../../system/api';

export default {
	changeLanguage: (params) => api.put("/users/" + params.userId + "/language", params),
};
